export default __webpack_public_path__ + "assets/visa-4e3ed034a8f2e0ecc3c4d1583ab63c88.svg";